var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountStatementIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.33317 0.333313C1.40817 0.333313 0.666504 1.07498 0.666504 1.99998V12C0.666504 12.925 1.40817 13.6666 2.33317 13.6666H15.6665C16.5915 13.6666 17.3332 12.925 17.3332 12V1.99998C17.3332 1.07498 16.5915 0.333313 15.6665 0.333313H2.33317ZM2.33317 1.99998H15.6665V5.33331H2.33317V1.99998ZM2.33317 6.99998H5.6665V8.66665H2.33317V6.99998ZM7.33317 6.99998H15.6665V8.66665H7.33317V6.99998ZM2.33317 10.3333H10.6665V12H2.33317V10.3333ZM12.3332 10.3333H15.6665V12H12.3332V10.3333Z",
    fill: "#C7222A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountStatementIcon);
export default __webpack_public_path__ + "static/media/accountStatementIcon.2e3d281916af513cdbe6f057ea8cea01.svg";
export { ForwardRef as ReactComponent };